import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useEffect, useState, useContext } from "react";
import ErrorMessage from "../../../Shared/Error/ErrorMessage";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { createItem, getPortalEntityTargetPage } from "../../../../API/Portal/Portal";
import { NO_ENTITY_AVAILABLE_OPTION, NO_PAGE_AVAILABLE_OPTION } from "./utils";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../Renderers/GlobalContext";
import { getEntities } from "../../../../API/Entity/Entity";

function CreateMenuItemDialog({ menuItems, portalId, projectId, onToggle, onCreate }) {

    const menuTypes = ["Sub Menu Item", "Recent Records", "Recent Lists"];

    const selectedId = "";

    const [formState, setFormState] = useState({
        name: "",
        type: "",
        entity: NO_ENTITY_AVAILABLE_OPTION,
        page: NO_PAGE_AVAILABLE_OPTION
    });

    const [entities, setEntities] = useState([]);
    const { organization } = useContext(GlobalContext).state
    const [pages, setPages] = useState([]);
    const { t, i18n } = useTranslation([
        "portal/menu_items"
    ], {
        useSuspense: false
    })

    useEffect(() => {
        const fetchEntities = async () => {
            const entities = await getEntities(projectId);
            // i18n.changeLanguage(organization.platformLanguage)
            const filteredEntities = getFilteredEntities(entities);
            setEntities(entities);
            setFormState(prevState => ({
                ...prevState,
                entity: filteredEntities.length === 0 ? NO_ENTITY_AVAILABLE_OPTION : filteredEntities[0]
            }));
        }
    
        fetchEntities();
    }, []);

    useEffect(() => {
        if (
            formState.entity &&
            formState.entity.id &&
            formState.entity.id.length > 0 &&
            formState.entity.id !== NO_ENTITY_AVAILABLE_OPTION.id
        ) {
            getPortalEntityTargetPage(portalId, formState.entity.id)
                .then(({ data }) => {
                    setPages(data)
                })
        }
    }, [formState.entity])

    function getFilteredEntities(entities) {
        if (selectedId) {
            return []
        }
        return entities.filter(entity => !(
            menuItems.some(menuItem => menuItem.entityId === entity.id)
        ))
    }

    function handleChange(event) {
        setFormState(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value,
        }))
    }

    async function createNewItem(e) {
        e.preventDefault();
        const properties = {
            name: formState.name,
            entityId: formState.entity.id,
            targetPageId: formState.page._id
        }
        const item = await createItem(projectId, portalId, properties);
        onCreate(item);
    }

    function isCreateDisabled() {
        return (
            formState.name.trim().localeCompare("") === 0 ||
            formState.page._id.localeCompare(NO_PAGE_AVAILABLE_OPTION._id) === 0 ||
            formState.entity.id.localeCompare(NO_ENTITY_AVAILABLE_OPTION.id) === 0
        )
    }

    function handleToggle() {
        onToggle();
    }

    return (
        <Dialog
            title={t("create_dialog.title")}
            onClose={handleToggle}
        >
            <form onSubmit={createNewItem}>
                <div className="form-label d-inline-block" required>
                    {t("create_dialog.menu_item_name_field_label")}
                </div>
                <input
                    className="form-control name-text"
                    maxLength="54"
                    autoFocus={true}
                    name="name"
                    onChange={handleChange}
                    value={formState.name}
                />
                {selectedId.trim().localeCompare("") !== 0 &&
                    <>
                        <div className="form-label d-inline-block">
                            {t("create_dialog.menu_type_field_label")}
                        </div>
                        <div className="w-100 mt-10">
                            <DropDownList
                                className="w-100"
                                name="type"
                                data={menuTypes}
                                onChange={handleChange}
                                value={formState.type}
                            />
                        </div>
                    </>
                }
                {
                    (
                        entities.length > 0 &&
                        selectedId !== ""
                    ) &&
                    <ErrorMessage
                        valid={false}
                        error={`All entities are used`}
                    />
                }
                <div className="form-label">
                    {t("create_dialog.target_object_field_label")}
                </div>
                <DropDownList
                    className="form-control-custom"
                    textField="name"
                    name="entity"
                    data={getFilteredEntities(entities)}
                    onChange={handleChange}
                    value={formState.entity}
                />

                <div className="form-label">
                    {t("create_dialog.target_object_field_label")}
                </div>
                <DropDownList
                    className="form-control-custom"
                    textField="pageName"
                    name="page"
                    data={pages}
                    onChange={handleChange}
                    value={formState.page}
                    loading={formState.arePagesLoading}
                />
            </form>
            <DialogActionsBar layout="end">
                <button
                    type={'button'}
                    className="btn btn-secondary mx-1"
                    onClick={handleToggle}
                >
                    {t("create_dialog.buttons.cancel_button_label")}
                </button>
                <button
                    type={'submit'}
                    className="btn btn-primary"
                    onClick={createNewItem}
                    disabled={isCreateDisabled()}
                >
                    {t("create_dialog.buttons.create_button_label")}
                </button>
            </DialogActionsBar>
        </Dialog>
    )
}

export default CreateMenuItemDialog;